// extracted by mini-css-extract-plugin
export var marqueeContent = "HeroSliderVertical-module--marqueeContent--3oIhg";
export var marqueeItem = "HeroSliderVertical-module--marqueeItem--2E1GN";